import React from 'react'
import { Helmet } from 'react-helmet'
import FooterBar from 'components/FooterBar'
import ManageRooms from '../Home/components/ManageRooms'
import { RoomsContainer } from './styles'

const Rooms = () => {

  return (
    <>
      <Helmet>
        <title>Rooms - Rook Hotel PMS</title>
        <meta name="description" content="Rooms - Rook Hotel PMS" />
      </Helmet>
      <RoomsContainer>
        <ManageRooms />
      </RoomsContainer>
      <FooterBar />
    </>
  );
};

export default Rooms;
